import { Item, Collection, timesQty, join } from "./collection_base"
import DataLoader from "#lib/data_loader"

// Weapons — a JSON array of catalog snapshots (name/wa/damage/shots/rof/rel/range/
// cost/notes), ordered, dupes allowed. Immutable identity looked up by slug.

const EDITABLE = ["name", "wa", "damage", "shots", "rof", "rel", "range", "cost", "notes"]

export class WeaponsItem extends Item {
  // Fill self: the editable snapshot controls + the catalog identity line. Moved here
  // from WeaponsCollection#fillItem — same body, now on the item via this.builder().
  async fill(entry) {
    const b = this.builder()
    const c = (await DataLoader.systemGet("weapons"))[entry.slug] || {}
    b.fill(entry, { fields: EDITABLE })
    b.text("identity", join(c.type, c.category, c.ammo || null, c.conc ? `conc ${c.conc}` : null))
  }

  // Blob entry from the STASH: slug + id + the editable snapshot fields, as stashed (no
  // numeric coercion — user's raw string stored verbatim). Template-variant-independent.
  entry() {
    const e = { slug: this.slugValue || "", id: this.get("id") }
    for (const f of EDITABLE) e[f] = this.get(f)
    return e
  }

  cost() { return timesQty({ cost: this.get("cost"), qty: this.get("qty") }) }
}

export class WeaponsCollection extends Collection {
  static CATALOGS = ["weapons"]

  // A new weapon snapshots the catalog's editable stats (the entry stores them, so it's
  // GM-editable and independent of later catalog changes).
  async newEntry(slug) {
    const c = (await DataLoader.systemGet("weapons"))[slug]
    if (!c) return null
    const entry = { slug }
    for (const f of EDITABLE) entry[f] = c[f]
    return entry
  }
}
